import ExceptionalCircumstances from './ExceptionalCircumstances';
import { TravelInsurance } from './TravelInsurance';

export default function NoRefundChangeDates() {
  return (
    <div>
      <h6>
        Unfortunately it's no longer possible to get a refund or change dates
      </h6>

      <p>
        As you are less than 2 months before the start of the trip, it's
        unfortunately no longer possible to get a refund. Please keep reading
        for details and alternative options.
      </p>

      <p>
        We do appreciate this may not the outcome you were hoping for.
        Unfortunately, by this point all bookings are treated as final, so that
        the local guides who run your trip can make all the arrangements. This
        typically includes booking accommodation, arranging transport, and
        making other preparations for your arrival.
      </p>

      <p>
        Please do continue to read below, and then we do still request that you
        cancel the spaces if you are not able to attend. This is so the guides
        know you are not coming.
      </p>

      <ExceptionalCircumstances />

      <TravelInsurance />
    </div>
  );
}
